<template>
  <div class="stat-container">
    <div class="main-stats">
      <div v-for="(count, index) in statistics.severityAmounts" :key="`severitycount-${index}`"
        :class="`main-stat stat-${statusNames[index]}`">
        <div class="stat-value">{{count}}</div>
        <div class="stat-title">{{statusNames[index]}}</div>
      </div>
    </div>
    <div class="distribution-bar">
      <div v-for="(count, index) in statistics.severityAmounts" :key="`distribution-${index}`"
        :class="`stat-${statusNames[index]}`" :style="`width:${severityPercentage(count)}%`"></div>
    </div>
    <div class="secondary-stats">
      <div class="secondary-stat">
        <div class="stat-value">{{items.length}}</div>
        <div class="stat-title">Total devices</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceStatusStats',
  props: {
    items: Array
  },
  data () {
    return {
      statusNames: ['normal', 'info', 'warning', 'minor', 'major', 'critical']
    }
  },
  methods: {
    /**
     * Convert count of items into percentage of total items
     *
     * @param {number} count The number of items
     */
    severityPercentage (count) {
      return (count / this.items.length) * 100
    }
  },
  computed: {
    /**
     * Calculate severity statistics
     *
     * @returns {Object} Object of statistics
     */
    statistics () {
      return this.items.reduce((previous, current) => {
        previous.severityAmounts[current.severity]++
        return previous
      }, {
        severityAmounts: [0, 0, 0, 0, 0, 0]
      })
    }
  }
}
</script>

<style scoped>
.stat-container {
    display:flex;
    flex-direction: column;
    gap: 1em;
    margin-top: 1em;
}

.main-stats{
    display: grid;
    grid-template-columns: repeat(3,1fr);
    flex-grow: 1;
    gap: 1em;
}

.main-stat{
    position: relative;
    padding-left: 1em;
}
.main-stat::before {
    content: '';
    position:absolute;
    left:0;
    top: 0;
    height:100%;
    width: 0.5em;
    border-radius: 1em;
    border: 0.8px solid black;
}

.stat-title{
    text-transform: capitalize;
}

.stat-value{
    font-weight: bold;
    font-size: 1.2em;
}

.distribution-bar {
    width: 100%;
    height:0.8em;
    border-radius: 1em;
    background-color: lightgrey;
    display: flex;
    overflow: hidden;
    border: 1px solid black;
}

.main-stat.stat-normal::before,
.distribution-bar .stat-normal {
    background-color: var(--col-normal);
}

.main-stat.stat-info::before,
.distribution-bar .stat-info {
    background-color: var(--col-info);
}

.main-stat.stat-warning::before,
.distribution-bar .stat-warning {
    background-color: var(--col-warning);
}

.main-stat.stat-minor::before,
.distribution-bar .stat-minor {
    background-color: var(--col-minor);
}

.main-stat.stat-major::before,
.distribution-bar .stat-major {
    background-color: var(--col-major);
}

.main-stat.stat-critical::before,
.distribution-bar .stat-critical {
    background-color: var(--col-critical);
}

.secondary-stats{
    display:flex;
    flex-direction: column;
    gap:0.2em;
}
.secondary-stat{
    display:flex;
    column-gap: 0.7em;
    align-items: center;
    flex-shrink: 1;

}
.secondary-stat .stat-value{
    font-size: 1.5em;
    width: 3em;
    flex-shrink: 0;
}
</style>
